

const Header = (props: any) => {
    return (<>
        <header>
            {props.children}
        </header>
    </>)
}
export default Header;